module.exports = __webpack_public_path__ + "img/banner-2.31c8fbba.jpg";